import { AxiosInstance, AxiosResponse } from "axios";
import { Reward } from "./reward.model";
import { useTPAxios } from "@/api/useTPAxios.ts";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { PaginatedResult } from "../wallet/wallet.service";

const listRewards = async (
  TPAxios: AxiosInstance
): Promise<Reward[]> => {
  const response = await TPAxios.get<AxiosResponse<PaginatedResult<Reward>>>(
    '/events/all?page=1&limit=10000',
  );

  return response.data.data.docs;
}

export const useListRewrads = () => {
  const TPAxios = useTPAxios();

  const options = queryOptions({
    queryKey: ['rewards'],
    queryFn: async () => await listRewards(TPAxios),
  });

  return useSuspenseQuery(options);
}